<template>
  <div>
    <b-form-select :options="options" v-model="file.content_status" />
    <b-alert :show="showAlert" :variant="file.meta.meta.document_type ? 'danger' : 'warning'" class="mt-3 mb-0">
      <h5 v-translate>Warning</h5>
      <p class="mb-0" v-translate>Your are about to set the OCR data of the file as reviewed but there still are empty fields. Are you sure you want to continue? <strong>This cannot be undone.</strong></p>
    </b-alert>
  </div>
</template>

<script>
export default {
  name: 'EditFieldShippingFilesContentStatus',
  props: {
    file: {
      type: Object,
      default: () => {},
      required: true
    },
    options: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  data() {
    return {
      originalProcessing: null
    }
  },
  computed: {
    showAlert() {
      return this.file.content_status === 'reviewed' && Object.values(this.file.meta.corrected_fields).some(x => (x === null || x === '')) // .indexOf('') !== -1
    }
  },
  watch: {
    'file.content_status': {
      deep: true,
      handler(val) {
        if (val === 'reviewed') {
          this.file.meta.meta.processing = 'corrected'
        } else {
          this.file.meta.meta.processing = this.originalProcessing
        }
      }
    }
  },
  mounted () {
    this.originalProcessing = this.file.meta.meta.processing
  }
}
</script>
